module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('div', {
    staticClass: "columns search buscar-solicitacoes no-print"
  }, [_c('form', {
    staticClass: "formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.obterCotas(1)
      }
    }
  }, [_c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_3"
  }, [_c('label', {
    attrs: {
      "for": "projeto"
    }
  }, [_vm._v("Projeto")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projeto),
      expression: "projeto"
    }],
    attrs: {
      "id": "projeto",
      "name": "projeto"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.projeto = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.projetos), function(projeto) {
    return _c('option', {
      domProps: {
        "value": projeto.Id
      }
    }, [_vm._v("\n                " + _vm._s(projeto.Nome) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna grade__coluna_4"
  }, [_c('label', {
    attrs: {
      "for": "empreendimento"
    }
  }, [_vm._v("Município")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeDaCidade),
      expression: "nomeDaCidade"
    }],
    attrs: {
      "id": "nomeDaCidade",
      "name": "nomeDaCidade",
      "type": "text",
      "maxlenght": "90",
      "placeholder": "Ex: Campo Grande"
    },
    domProps: {
      "value": (_vm.nomeDaCidade)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeDaCidade = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel,
      "mensagem": _vm.loading.mensagem
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "columns search buscar-solicitacoes no-print"
  }, [_c('div', {
    staticClass: "column control"
  }, [_c('router-link', {
    staticClass: "botao botao_medio botao_cor-terciaria",
    attrs: {
      "to": {
        name: 'CadastrarCota'
      }
    }
  }, [_c('span', [_vm._v("Nova cota")])])], 1)]), _vm._v(" "), _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.cotas), function(cota) {
    return (_vm.cotas.length > 0) ? _c('tr', {
      attrs: {
        "id": cota.Id
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(cota.CidadeNome) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(cota.ProjetoNome) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "u-texto-alinhado-ao-centro"
    }, [_vm._v("\n            " + _vm._s(cota.QuantidadeUsada) + " /" + _vm._s(cota.Quantidade) + "\n          ")]), _vm._v(" "), _c('td', {
      staticClass: "ver-detalhes no-print"
    }, [_c('div', [_c('button', {
      staticClass: "botao botao_cor-terciaria botao_contorno botao_pequeno",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.redirecionarParaVisualizacao(cota.Id)
        }
      }
    }, [_vm._v("Visualizar")])])])]) : _vm._e()
  }), _vm._v(" "), (_vm.cotas.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n            Nenhuma cota encontrada\n          ")])]) : _vm._e()], 2)]), _vm._v(" "), _c('paginacao', {
    attrs: {
      "paginaAtual": _vm.paginaAtual,
      "totalDePaginas": _vm.totalDePaginas,
      "totalDeRegistros": _vm.totalDeRegistros
    },
    on: {
      "paginar": _vm.obterCotas
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grade__linha grade__linha_alinhar-vertical-a-base"
  }, [_c('div', {
    staticClass: "grade__coluna grade__coluna_1"
  }, [_c('button', {
    staticClass: "botao botao_cinza botao_grande",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n              Filtrar\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Município")]), _vm._v(" "), _c('th', [_vm._v("Projeto")]), _vm._v(" "), _c('th', {
    staticClass: "u-texto-alinhado-ao-centro"
  }, [_vm._v("Cotas")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c04f9d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestao-de-cotas/ListaDeCotas.vue
// module id = 1111
// module chunks = 1